import {Alert} from "react-bootstrap";
// @ts-ignore
import classes from "./index.module.css";

const Loading:React.FC<{overrideStyle?: string}> = (props) => {

    const componentStyle = props.overrideStyle !== undefined ? props.overrideStyle : "display-5";

    return (<Alert variant="primary">
        <span className={classes.loader} />
        <span className={[classes.content, componentStyle].join(" ")}>Loading...</span>
    </Alert>);
}

export default Loading;